import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';

import { SignUp as SignUpComponent } from '../../components';
import { useAuthContext } from '../../providers/AuthContextProvider';

export function SignUp() {
  const { status } = useAuthContext();
  const [params] = useSearchParams();

  if (status === 'authorized') {
    return <Navigate to={params.get('redirect') || `/`} />;
  }

  return (
    <>
      <Routes>
        <Route path="" element={<SignUpComponent />} />
      </Routes>
    </>
  );
}

export default SignUp;
